import React from "react";
import { Instagram, Linkedin } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { logoUrl, socials, contactInfo } from "../mock";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="bg-[#111111] text-white/80" data-nav-theme="dark">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img
            src={logoUrl}
            alt="Maison Labroca"
            className="h-12 w-auto object-contain"
            style={{ filter: "brightness(0) invert(1)" }}
          />
          <p className="mt-6 text-white/70 max-w-sm text-[14px] leading-relaxed">
            Entreprise familiale fondée en {contactInfo.founded}. Construction
            résidentielle, rénovation et programmes immobiliers en Île-de-France.
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="uppercase text-[11px] tracking-[0.25em] text-white/50 mb-4">Navigation</h4>
          <ul className="space-y-3 text-[14px]">
            <li><button onClick={() => navigate("/")} className="hover:text-[#9F8B76]">Accueil</button></li>
            <li><button onClick={() => navigate("/realisations")} className="hover:text-[#9F8B76]">Réalisations</button></li>
            <li><button onClick={() => navigate("/rachat-de-propriete")} className="hover:text-[#9F8B76]">Rachat de propriété</button></li>
            <li><button onClick={() => navigate("/a-propos")} className="hover:text-[#9F8B76]">À propos</button></li>
            <li><button onClick={() => navigate("/contact")} className="hover:text-[#9F8B76]">Contact</button></li>
            <li><button onClick={() => navigate("/contact")} className="hover:text-[#9F8B76]">Mentions légales</button></li>
            <li><button onClick={() => navigate("/contact")} className="hover:text-[#9F8B76]">Politique de confidentialité</button></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="uppercase text-[11px] tracking-[0.25em] text-white/50 mb-4">Contact</h4>
          <a
            href={`mailto:${contactInfo.email}`}
            className="text-[14px] hover:text-[#9F8B76] break-all"
          >
            {contactInfo.email}
          </a>
          <p className="mt-3 text-white/70 text-[14px]">{contactInfo.location}</p>

          <div className="mt-6 flex items-center gap-3">
            <a
              href={socials.linkedin}
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
              className="w-10 h-10 rounded-full border border-white/25 flex items-center justify-center hover:bg-[#9F8B76] hover:border-[#9F8B76] transition-colors"
            >
              <Linkedin className="w-4 h-4" strokeWidth={1.8} />
            </a>
            <a
              href={socials.instagram}
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              className="w-10 h-10 rounded-full border border-white/25 flex items-center justify-center hover:bg-[#9F8B76] hover:border-[#9F8B76] transition-colors"
            >
              <Instagram className="w-4 h-4" strokeWidth={1.8} />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1500px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-[11px] text-white/50">
          <p>© {new Date().getFullYear()} Maison Labroca. Tous droits réservés.</p>
          <p className="uppercase tracking-widest">Construction · Rénovation · Programmes d'envergure</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
